// extracted by mini-css-extract-plugin
export default {"keyValueListContainer":"Lb2mxY"};